import firebase from '../../firebase';

export default async function getGroupUserCards({ groupId, userId }) {
    const cards = await firebase.functions().httpsCallable('billing-getGroupUserCards')({ groupId, userId });
    if (cards && cards.data) {
        return cards.data;
    }
    return [];
}
